import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import { capitalize } from 'underscore.string';

const ResourceItem = ({ resource }) => (
    <div className={`col-md-3 col-sm-4 col-xs-6 item ${resource.category}`} id={`resource-${resource.id}`}>
        <div className="image">
            <span style={{ backgroundImage: `url(${resource.image})` }} className="image-img" />
            <div className="overlay">
                <Link className="item-overlay-link" to={`resources/view/${resource.id}`}>
                    <span>Link to resource</span>
                </Link>
                <div className="overlay-inner">
                    <div className="details">
                        <h5><i className="fa fa-graduation-cap" /> {capitalize(resource.category)}</h5>
                        <h6>{resource.title}</h6>
                    </div>
                    <Link className="item-icon" to={`resources/view/${resource.id}`}>
                        VIEW <i className="fa fa-eye" />
                    </Link>
                </div>
            </div>
        </div>
    </div>
);

ResourceItem.propTypes = {
    resource: PropTypes.object.isRequired
};

export default ResourceItem;



/** WEBPACK FOOTER **
 ** ./src/components/ResourceItem.js
 **/